import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import notFound from "pages/notFound";
import DownloadJDGJSApp1 from "pages/download/jdgjs/app1.js";

// SEO H5下載列表
// DownloadHKJYAPP1
// DownloadHKJYAPP2
// DownloadHKJYAPP3
// DownloadLJAJYAPP1
// DownloadLJAJYAPP2
// DownloadYTJYAPP1
// DownloadYTJYAPP2
// DownloadJDGJSApp1

export default () => (
	<Router>
		<Switch>
			<Route exact path="/" component={DownloadJDGJSApp1} />
			<Route path="*" component={notFound} />
		</Switch>
	</Router>
);
